export interface ISaveHardToMatchDonorReviewRequest {
    recipientId: number,
    donorId: number,
    status: number | null,
    note: string | null
}

export interface IHardToMatchDonorReviewResult {
    reviewStatus: number | null,
    reviewNote: string | null,
    reviewUpdatedDate: string,
    reviewStatusDescription: string | null,
    isHidden: boolean
}

export interface IHardToMatchDonorReviewStatus {
    id: number,
    description: string,
    hidesPair: boolean
}
